import React from 'react';
import AlertForm from '../components/Alerts/AlertForm';
import AlertList from '../components/Alerts/AlertList';
import { useAlerts } from '../hooks/useAlerts';

export default function AlertsPage() {
  const { alerts, loading, error, createAlert, deleteAlert, toggleAlert } = useAlerts();

  return (
    <div className="alerts-page">
      <h2>Alerts</h2>
      <p className="page-description">
        Create alerts to get notified when new cards matching your criteria are found during scrapes.
      </p>

      {error && <div className="error-message">{error}</div>}

      <AlertForm onCreateAlert={createAlert} />

      {loading ? (
        <p>Loading alerts...</p>
      ) : (
        <AlertList
          alerts={alerts}
          onToggle={toggleAlert}
          onDelete={deleteAlert}
        />
      )}
    </div>
  );
}
